import { render, staticRenderFns } from "./zhipai.vue?vue&type=template&id=d9ed22fc&scoped=true&"
import script from "./zhipai.vue?vue&type=script&lang=js&"
export * from "./zhipai.vue?vue&type=script&lang=js&"
import style0 from "./zhipai.vue?vue&type=style&index=0&id=d9ed22fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9ed22fc",
  null
  
)

export default component.exports